// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uxjE","largestCol":"styles_largestCol__1SuwV","smallestCol":"styles_smallestCol__3HYvf"};